import React from 'react';
import { Spinner } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Types = () => {
  return (
    <div>
      <h4 className="mt-5">Types</h4>
      <p>
        Use any of the available spinners by changing the <i>type </i> prop.
      </p>
      <div className="btn-group btns mt-3">
        <Spinner className="single-btn" />
        <Spinner className="single-btn" type="secondary" />
        <Spinner className="single-btn" type="danger" />
       
      </div>
      <div className="btn-group btns mt-3">
        <Spinner className="single-btn" type="success" />
        <Spinner className="single-btn" type="warning" />
        <Spinner className="single-btn" type="blue" />
         
      </div>

      <Row className="mt-5" fluid>
        <code>
          {'import { Spinner } from "chic-ui";'}
          <br />
          {'<Spinner />'}
          <br />
          {'<Spinner type="secondary" />'}
          <br />
          {'<Spinner type="danger" />'}
          <br />
          {'<Spinner type="success" />'}
          <br />
          {'<Spinner type="warning" />'}
          <br />
          {'<Spinner type="blue" />'}
        </code>
      </Row>
    </div>
  );
};

export default Types;
